import React, { FC, ReactElement } from "react";
import { Link } from "react-router-dom";
import MuiChip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

interface ChipProps {
  link?: string;
  label: string;
  icon?: ReactElement;
  color?: string;
  marginBottom?: string;
  backgroundColor?: string;
  hoverTextColor?: string;
  hoverBackgroundColor?: string;
}

// Modifica el componente estilizado para aplicar estilos de hover
const StyledMuiChip = styled(MuiChip)<ChipProps>(
  ({ theme, color, backgroundColor, hoverTextColor, hoverBackgroundColor }) => ({
    cursor: "pointer",
    color: color,
    backgroundColor: backgroundColor,
    "&:hover": {
      color: hoverTextColor,
      backgroundColor: hoverBackgroundColor,
    },
  })
);

const Chip: FC<ChipProps> = ({
  link = "",
  label,
  icon,
  color = "",
  marginBottom = "0.5rem",
  backgroundColor,
  hoverTextColor,
  hoverBackgroundColor,
}) => {
  return (
    <div style={{ marginBottom }}>
      <Link to={link}>
        <StyledMuiChip
          icon={icon}
          label={label}
          color={color as "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"}
          backgroundColor={backgroundColor}
          hoverTextColor={hoverTextColor}
          hoverBackgroundColor={hoverBackgroundColor}
        />
      </Link>
    </div>
  );
};

export default Chip;
